let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aDM8S")).then(() => parcelRequire('bKikv'));